import { render, staticRenderFns } from "./ScenarioAllocationCard.vue?vue&type=template&id=5184577e&scoped=true&"
import script from "./ScenarioAllocationCard.vue?vue&type=script&lang=js&"
export * from "./ScenarioAllocationCard.vue?vue&type=script&lang=js&"
import style0 from "./ScenarioAllocationCard.vue?vue&type=style&index=0&id=5184577e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5184577e",
  null
  
)

export default component.exports